import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';

import { GridViewModel } from '@models/module/grid';
import { HttpService } from '@shared/services';

import { ModuleRelation, ModuleRelationStateMapping } from './module-config.model';

@Injectable({ providedIn: 'root' })
export class ModuleRelationsService {
  private readonly http = inject(HttpService);

  private options(moduleId: number, params: Record<string, unknown> = {}) {
    return {
      useLoader: false,
      httpOptions: { params: this.http.buildHttpParams(params), headers: { moduleId: moduleId.toString() } },
    };
  }

  search(moduleId: number, moduleTypeId: number): Observable<ModuleRelation[]> {
    return this.http
      .post<GridViewModel<ModuleRelation[]>>('_api/ModuleRelation/Search', {}, this.options(moduleId, { moduleTypeId }))
      .pipe(map(result => result?.data ?? []));
  }

  add(moduleId: number, body: Partial<ModuleRelation>) {
    return this.http.post('_api/ModuleRelation/Add', body, this.options(moduleId));
  }

  edit(moduleId: number, body: Partial<ModuleRelation>) {
    return this.http.put('_api/ModuleRelation/Edit', body, this.options(moduleId));
  }

  delete(moduleId: number, id: number) {
    return this.http.put('_api/ModuleRelation/Delete', [id], this.options(moduleId));
  }

  togglePartialPayment(moduleId: number, id: number, childFieldId: number) {
    return this.http.put('_api/ModuleRelation/TogglePartialPayment', { id, childFieldId }, this.options(moduleId));
  }

  getStateMappings(moduleId: number, relationId: number): Observable<ModuleRelationStateMapping[]> {
    return this.http
      .get<
        ModuleRelationStateMapping[]
      >('_api/ModuleRelation/GetRelationStateMappings', this.options(moduleId, { relationId }))
      .pipe(map(mappings => mappings ?? []));
  }

  syncStateMappings(moduleId: number, relationId: number, mappings: ModuleRelationStateMapping[]) {
    return this.http.put(
      '_api/ModuleRelation/SyncRelationStateMappings',
      mappings,
      this.options(moduleId, { relationId }),
    );
  }
}
